const url = window.location.href;
const matches = url.match(/^http(s?)?\:\/\/([^\/?#]+)/);
const baseUrl = matches[0];
const websocketUrl = baseUrl.replace('http', 'ws') + '/ws/';

export const environment = {
  production: false,
  baseUrl,
  websocketUrl,
  sentry: {
    // this variable will be replace in gitlab ci/cd. see more in file .gitlab-ci/5-tag-prod.gitlab-ci.yml
    dsn: 'https://bf7c925d6e0034b97f8d75a73db50f99@sentry.c0d1um.io/98',
    environment: 'DEV_FE',
    debug: true,
  },
};

export const featureFlag = {
  page_title: '',
  ddoc: false,
  memo_enable: false,
  econtract_enable: false,
  ddoc_enable_feature_26: false,
  ddoc_enable_feature_28: false,
  timestamp_memo_enable: false,
  ndid: false,
  login_adfs_enable: false,
  maintenance_mode: false,
  maintenance_message_th: '',
  maintenance_message_en: '',
  sms_otp: false,
  email_otp: false,
  thaicom: false,
  self_service_form: false,
  google_client_id: '',
  export_memo_google_drive_enable: false,
  contract_ddoc: false,
  contract_ddoc_enable_feature_26: false,
  contract_ddoc_enable_feature_28: false,
  contract_timestamp_memo_enable: false,
  contract_sms_otp: false,
  contract_email_otp: false,
  contract_ndid: false,
  contract_thaicom: false,
  media_url_need_authentication: true,
  storage_space_status: '',
  storage_subscription_status: '',
  package_subscription_status: '',
  additional_vm_subscription_status: '',
  contract_estamp_enable: false,
};
